<template>
    <v-runtime-template :template="ResubscribeTemplate" />
</template>

<script>
    import { mapState } from 'vuex';
    import VRuntimeTemplate from "v-runtime-template";    

    export default {
        computed: {
            ...mapState([
                'Strings',
                'NLSubLink'
            ]),
            ResubscribeTemplate() {
                return this.Strings['Forms.NewsletterUnsub.Resubscribe'];
            },
            SubscribeLink() {
                return this.NLSubLink;
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>